import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
} from '@angular/core';
// global.d.ts
declare const bootstrap: any;

@Directive({
  selector: '[ncsTooltip]',
})
export class NcsTooltipDirective implements AfterViewInit {
  @Input('ncsTooltip') tooltipText!: string;
  tooltipElement: HTMLElement | null = null; // Allow null as a type

  constructor(private el: ElementRef) { }

  @HostListener('mouseenter') onMouseEnter() {
    this.createTooltip();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.destroyTooltip();
  }

  private createTooltip() {
    this.tooltipElement = document.createElement('div');
    this.tooltipElement.innerText = this.tooltipText;
    this.tooltipElement.className = 'tooltip';
    this.tooltipElement.style.position = 'absolute';
    this.tooltipElement.style.backgroundColor = '#333';
    this.tooltipElement.style.color = '#fff';
    this.tooltipElement.style.padding = '5px';
    this.tooltipElement.style.borderRadius = '5px';
    this.tooltipElement.style.zIndex = '1000';

    // Position the tooltip
    const rect = this.el.nativeElement.getBoundingClientRect();
    this.tooltipElement.style.left = `${rect.left + window.scrollX}px`;
    this.tooltipElement.style.top = `${rect.top + window.scrollY - 30}px`; 

    document.body.appendChild(this.tooltipElement);
  }

  private destroyTooltip() {
    let _self = this;
    if (this.tooltipElement) {
      document.body.removeChild(this.tooltipElement);
      _self.tooltipElement = null;
    }
  }

  ngAfterViewInit() {
    
    new bootstrap.Tooltip(this.el.nativeElement);
  }
}